import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useQueryJobCount from "../view/useQueryJobCount.js";

export default function JobByEmployerCountItem(props) {
  const { employerId } = props;
  const { data: count, loading, errors } = useQueryJobCount({employerId});

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <Row>
            <Col>
              <span>{count}</span>
            </Col>
          </Row>
        )}
      />
    </HorizontalLoader>
  );
}
